<template>
  <Teleport to="body">
  <template v-if="visivel">
  <div class="modal fade show d-block" tabindex="-1" @click.self="fechar">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable crm-modal-wide">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ rotulo ? 'Editar Etiqueta' : 'Nova Etiqueta' }}</h5>
          <button type="button" class="btn-close" @click="fechar"></button>
        </div>
        <form @submit.prevent="salvar">
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Nome <span class="text-danger">*</span></label>
              <input v-model="form.nome" type="text" class="form-control" :class="{ 'is-invalid': erros.nome }" />
              <div v-if="erros.nome" class="invalid-feedback">{{ erros.nome }}</div>
            </div>
            <BRow>
              <BCol md="6">
                <div class="mb-3">
                  <label class="form-label">Categoria</label>
                  <input v-model="form.categoria" type="text" class="form-control" />
                </div>
              </BCol>
              <BCol md="6">
                <div class="mb-3">
                  <label class="form-label">Cor</label>
                  <input v-model="form.cor_referencia" type="color" class="form-control form-control-color w-100" />
                </div>
              </BCol>
            </BRow>
            <div class="mb-3">
              <label class="form-label">Descrição</label>
              <textarea v-model="form.descricao" class="form-control" rows="2"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <BButton variant="ghost-dark" @click="fechar">Cancelar</BButton>
            <BButton type="submit" variant="success" :disabled="salvando">
              <BSpinner v-if="salvando" small class="me-1" />
              {{ salvando ? 'Salvando...' : 'Salvar' }}
            </BButton>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" @click="fechar"></div>
  </template>
  </Teleport>
</template>

<script>
import axios from 'axios';
import { sucesso, erro } from '@/helpers/common/api';

export default {
  name: 'RotuloModal',
  props: {
    visivel: { type: Boolean, default: false },
    rotulo: { type: Object, default: null },
  },
  emits: ['fechar', 'salvo'],
  data() {
    return {
      form: { nome: '', descricao: '', categoria: '', cor_referencia: '#3b82f6' },
      erros: {},
      salvando: false,
    };
  },
  watch: {
    rotulo: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            nome: val.nome || '',
            descricao: val.descricao || '',
            categoria: val.categoria || '',
            cor_referencia: val.cor_referencia || '#3b82f6',
          };
        } else {
          this.form = { nome: '', descricao: '', categoria: '', cor_referencia: '#3b82f6' };
        }
        this.erros = {};
      },
    },
  },
  methods: {
    validar() {
      this.erros = {};
      if (!this.form.nome) this.erros.nome = 'Nome é obrigatório.';
      return Object.keys(this.erros).length === 0;
    },
    async salvar() {
      if (!this.validar()) return;
      this.salvando = true;
      try {
        const resp = this.rotulo
          ? await axios.put(`/rotulo/${this.rotulo.id}`, this.form)
          : await axios.post('/rotulo', this.form);
        const data = resp?.data?.data ?? resp?.data;
        sucesso();
        this.$emit('salvo', data);
        this.$emit('fechar');
      } catch (e) {
        const msg = e?.response?.data?.error
          || (e?.response?.data?.issues && e.response.data.issues.map((i) => i.message).join(', '))
          || e?.message
          || 'Falha ao salvar etiqueta.';
        erro({ title: 'Não foi possível salvar', text: msg });
      } finally {
        this.salvando = false;
      }
    },
    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 1055;
}
.modal-backdrop {
  z-index: 1040;
  cursor: pointer;
}

.crm-modal-wide {
  max-width: min(1200px, calc(100vw - 1rem));
}
</style>
